// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState, useContext, useMemo, useCallback, useRef } from 'react';
import { useRouteMatch, useLocation } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { useAlert } from 'react-alert';
import { Notification } from '../../../types/Model';
import LogoIcon from '../../../assets/images/logo.svg';
import HomeIcon from '../../../assets/images/header-home-icon.svg';
import HomeActiveIcon from '../../../assets/images/header-home-active-icon.svg';
import ChallengeIcon from '../../../assets/images/header-challenge-icon.svg';
import ChallengeActiveIcon from '../../../assets/images/header-challenge-active-icon.svg';
import OnlineCourseIcon from '../../../assets/images/header-online-course-icon.svg';
import OnlineCourseActiveIcon from '../../../assets/images/header-online-course-active-icon.svg';
import LabIcon from '../../../assets/images/header-lab-icon.svg';
import LabActiveIcon from '../../../assets/images/header-lab-active-icon.svg';
import ExamIcon from '../../../assets/images/header-exam-icon.svg';
import ExamActiveIcon from '../../../assets/images/header-exam-active-icon.svg';
import NotificationIcon from './NotificationIcon';
import LanguageIcon from './LanguageIcon';
import IconButton from '../../../components/IconButton';
import { WebSocketContext } from '../../../contexts/WebSocketContext';
import MemberContext from '../../../contexts/MemberContext';
import S from './styles';
import { Link } from 'react-router-dom';
import { RunningLabSourceFrom, RunningLabStatus } from '../../../types/Model';

import { useDispatch, useSelector } from 'react-redux';
import runningLabSelector from '../../../redux/selectors/runningLabSelector';
import runningChallengeSelector from '../../../redux/selectors/runningChallengeSelector';
import runningExamSelector from '../../../redux/selectors/runningExamSelector';
import { updateRunningLabAction, clearRunningLabAction } from '../../../redux/actionCreators/runningLabAction';
import { updateRunningChallengeAction, clearRunningChallengeAction } from '../../../redux/actionCreators/runningChallengeAction';
import { updateRunningExamAction, clearRunningExamAction } from '../../../redux/actionCreators/runningExamAction';
import { FormattedMessage, useIntl } from 'react-intl';

type PopupType = 'language' | 'notification' | 'member' | null;
export interface HeaderProps extends React.ComponentPropsWithRef<'header'> {
  getNotifications: Function;
  readNotification: Function;
  getResetNotifications: Function;
  isNotificationFetching: boolean;
  isResetingNotifications: boolean;
  unreadNotifications: number;
  notificationsList: Notification[];
  bodyRef: React.MutableRefObject<HTMLDivElement | null>;
  notificationsCount: number;
}

const Header: React.FC<HeaderProps> = (props) => {
  const {
    getNotifications,
    readNotification,
    bodyRef,
    notificationsList,
    isNotificationFetching,
    notificationsCount,
    getResetNotifications,
    isResetingNotifications,
    unreadNotifications,
    ...otherProps
  } = props;
  const alert = useAlert();
  const nodeRef = useRef(null);
  const isHomeMatch = useRouteMatch('/home') !== null;
  const isOnlineCoursesMatch = useRouteMatch(['/onlineCourses', '/onlineCourses/:id', '/onlineCourses/:id/chapters']) !== null;
  const labsMatch = useRouteMatch('/labs');
  const labMatch = useRouteMatch<{ id: string }>('/labs/:id');
  const challengesMatch = useRouteMatch('/challenges');
  const challengeMatch = useRouteMatch<{ id: string }>('/challenges/:id');
  const examsMatch = useRouteMatch('/exams');
  const examMatch = useRouteMatch<{ id: string }>('/exams/:id');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const runningLab = useSelector(runningLabSelector.makeRunningLab())
  const runningChallenge = useSelector(runningChallengeSelector.makeRunningChallenge())
  const runningExam = useSelector(runningExamSelector.makeRunningExam())
  const dispatch = useDispatch()
  const intl = useIntl();

  const member = useContext(MemberContext);

  const location = useLocation();
  const websocket = useContext(WebSocketContext);

  function fetchDataNotification() {
    getNotifications({ page: 1, limit: (10 * currentPage) });
  }

  useEffect(() => {
    if (member.isLogin) {
      fetchDataNotification();
    }
  }, [currentPage, unreadNotifications]);
  useEffect(() => {
    if (!isResetingNotifications) {
      member.update();
      console.log('updating')
    }
  }, [isResetingNotifications])

  useEffect(() => {
    if (member.isLogin) {
      fetchDataNotification();
    }
  }, [location.pathname]);

  useEffect(() => {
    function messageHandler(message: any) {
      // console.log('socket triggered!', { message });
      const data = JSON.parse(message.data);
      if (data.env == 'Challenge') {
        switch (data.type) {
          case RunningLabStatus.Prewarm: {
            alert.show('E069', { type: 'info' });
            dispatch(updateRunningChallengeAction({ status: RunningLabStatus.Prewarm }))
            break;
          }
          case RunningLabStatus.Run: {
            alert.show('E017', { type: 'success' });
            dispatch(updateRunningChallengeAction({ status: RunningLabStatus.Run }))
            member.update();
            break;
          }
          case RunningLabStatus.Error: {
            alert.show('E021', { type: 'error' });
            dispatch(updateRunningChallengeAction({ status: RunningLabStatus.Error }))
            break;
          }
          case RunningLabStatus.Stop: {
            dispatch(clearRunningChallengeAction())
            member.update();
            break;
          }
          default: {
            getNotifications({ page: 1, limit: 10 });
            break;
          }
        }
      } else if (data.env == 'Lab') {
        switch (data.type) {
          case RunningLabStatus.Prewarm: {
            alert.show('E019', { type: 'info' });
            dispatch(updateRunningLabAction({ status: RunningLabStatus.Prewarm }))
            break;
          }
          case RunningLabStatus.Run: {
            alert.show('E017', { type: 'success' });
            dispatch(updateRunningLabAction({ status: RunningLabStatus.Run }))
            member.update();
            break;
          }
          case RunningLabStatus.Error: {
            alert.show('E021', { type: 'error' });
            dispatch(updateRunningLabAction({ status: RunningLabStatus.Error }))
            break;
          }
          case RunningLabStatus.Stop: {
            dispatch(clearRunningLabAction())
            member.update();
            break;
          }
          default: {
            getNotifications({ page: 1, limit: 10 });
            break;
          }
        }
      }
    }

    websocket?.websocket?.addEventListener('message', messageHandler);

    return () => {
      websocket?.websocket?.removeEventListener('message', messageHandler);
    }
  }, [websocket]);

  const renderLabCondition = () => {
    if (runningLab && runningLab.status === RunningLabStatus.Error) {
      return <S.BadgeError />
    }

    switch (member.runningLab?.status) {
      case RunningLabStatus.Run: {
        return <S.Badge />
      }
      case RunningLabStatus.Prewarm:
      case RunningLabStatus.Starting: {
        return <S.BadgeDeploying />
      }
      case RunningLabStatus.Stop:
      default: {
        return null;
      }
    }
  };

  const renderChallengeCondition = () => {
    if (runningChallenge && runningChallenge.status === RunningLabStatus.Error) {
      return <S.BadgeError />
    }

    switch (member.runningChallenge?.status) {
      case RunningLabStatus.Run: {
        return <S.Badge />
      }
      case RunningLabStatus.Prewarm:
      case RunningLabStatus.Starting: {
        return <S.BadgeDeploying />
      }
      case RunningLabStatus.Stop:
      default: {
        return null;
      }
    }
  };

  const renderExamCondition = () => {
    if (runningExam && runningExam.status === RunningLabStatus.Error) {
      return <S.BadgeError />
    }

    switch (member.runningExam?.status) {
      case RunningLabStatus.Run: {
        return <S.ExamBadge />
      }
      case RunningLabStatus.Stop:
      default: {
        return null;
      }
    }
  };

  const renderActions = () => {
    if (!member.isLogin) {
      return (
        <S.LoginContainer as={Link} to="/login">
          <S.UserIcon />
          <S.LoginText><FormattedMessage id="A004" /></S.LoginText>
        </S.LoginContainer>
      )
    }
    return (
      <>
        <S.ActionItem active={popup === 'notification'} onClick={toggleNotificationPopup}>
          <NotificationIcon unread={member.newMessage > 0} active={popup === 'notification'} />
        </S.ActionItem>
        <CSSTransition
          in={popup === 'notification'}
          timeout={300}
          classNames="alert"
          nodeRef={nodeRef}
          unmountOnExit
        >
          <S.NotificationPopup
            closePopup={closePopup}
            bodyRef={bodyRef}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            notificationsList={notificationsList}
            getResetNotifications={getResetNotifications}
            notificationsCount={notificationsCount}
            readNotification={readNotification}
            isNotificationFetching={isNotificationFetching} />
        </CSSTransition>

        <S.AvatarContainer>
          <S.Avatar onClick={toggleMemberPopup} />
          {popup === 'member' && (<S.MemberPopup closePopup={closePopup} />)}
        </S.AvatarContainer>
      </>
    )
  }

  const labUrl = useMemo(() => {
    if (runningLab.status !== RunningLabStatus.Stop) {
      const query = runningLab.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${runningLab.sourceId}` :
        runningLab.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' : ''
      const labUrl = '/labs/' + runningLab.id + query;

      const url = location.pathname + location.search;
      if (runningLab.status === RunningLabStatus.Error || labUrl !== url) {
        return labUrl;
      }
    }

    return '/labs';
  }, [location, runningLab])

  const handleClickLab = () => {
    if (runningLab.status === RunningLabStatus.Error) {
      dispatch(clearRunningLabAction());
      member.update();
    }
  }

  const challengeUrl = useMemo(() => {
    if (runningChallenge.status !== RunningLabStatus.Stop) {
      const query = runningChallenge.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${runningChallenge.sourceId}` :
        runningChallenge.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' : ''
      const challengeUrl = '/challenges/' + runningChallenge.id + query;

      const url = location.pathname + location.search;
      if (runningChallenge.status === RunningLabStatus.Error || challengeUrl !== url) {
        return challengeUrl;
      }
    }

    return '/challenges';
  }, [location, runningChallenge])

  const handleClickChallenge = () => {
    if (runningChallenge.status === RunningLabStatus.Error) {
      dispatch(clearRunningChallengeAction());
      member.update();
    }
  }

  const examUrl = useMemo(() => {
    if (runningExam.status !== RunningLabStatus.Stop) {
      const query = runningExam.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${runningExam.sourceId}` :
        runningExam.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' : ''
      const examUrl = '/exams/' + runningExam.id + query;

      const url = location.pathname + location.search;
      if (runningExam.status === RunningLabStatus.Error || examUrl !== url) {
        return examUrl;
      }
    }

    return '/exams';
  }, [location, runningExam])

  const handleClickExam = () => {
    if (runningExam.status === RunningLabStatus.Error) {
      dispatch(clearRunningExamAction());
      member.update();
    }
  }

  const labActive = labsMatch !== null || labMatch !== null;
  const challengeActive = challengesMatch !== null || challengeMatch !== null;
  const examActive = examsMatch !== null || examMatch !== null;

  const [popup, setPopup] = useState<PopupType>();

  const toggleLanguagePopup = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setPopup(popup === 'language' ? null : 'language');
  }, [popup]);

  const toggleNotificationPopup = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setPopup(popup === 'notification' ? null : 'notification');
  }, [popup]);

  const toggleMemberPopup = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setPopup(popup === 'member' ? null : 'member');
  }, [popup]);

  const closePopup = useCallback(() => setPopup(null), [])

  useEffect(() => {
    if (popup) {
      window.addEventListener('click', closePopup);
    }

    return () => {
      window.removeEventListener('click', closePopup);
    }
  }, [popup]);

  return (
    <S.Container {...otherProps}>
      <S.Logo src={LogoIcon} alt="Logo" />
      { location.pathname.includes('examReview') ? (
        <S.ActionItems>
          <S.ActionItem active={popup === 'language'} onClick={toggleLanguagePopup}>
            <LanguageIcon active={popup === 'language'} />
            {popup === 'language' && <S.LanguagePopup closePopup={closePopup} />}
          </S.ActionItem>
        </S.ActionItems>
      ) : (
        <>
          <S.MenuItem active={isHomeMatch} to="/home">
            <IconButton
              icon={HomeIcon}
              active={isHomeMatch}
              activeIcon={HomeActiveIcon}
              text={intl.formatMessage({ id: 'A001' })}
            />
          </S.MenuItem>
          <S.MenuItem active={isOnlineCoursesMatch} to="/onlineCourses">
            <IconButton
              icon={OnlineCourseIcon}
              active={isOnlineCoursesMatch}
              activeIcon={OnlineCourseActiveIcon}
              text={intl.formatMessage({ id: 'A002' })}
            />
          </S.MenuItem>
          <S.MenuItem active={labActive} to={labUrl} onClick={handleClickLab}>
            <S.IconWrapper>
              <IconButton
                icon={LabIcon}
                active={labActive}
                activeIcon={LabActiveIcon}
                text={intl.formatMessage({ id: 'A003' })}
              />
              {renderLabCondition()}
            </S.IconWrapper>
          </S.MenuItem>
          <S.MenuItem active={challengeActive} to={challengeUrl} onClick={handleClickChallenge}>
            <S.IconWrapper>
              <IconButton
                icon={ChallengeIcon}
                active={challengeActive}
                activeIcon={ChallengeActiveIcon}
                text={intl.formatMessage({ id: 'A011' })}
              />
              {renderChallengeCondition()}
            </S.IconWrapper>
          </S.MenuItem>
          <S.MenuItem active={examActive} to={examUrl} onClick={handleClickExam}>
            <S.IconWrapper>
              <IconButton
                icon={ExamIcon}
                active={examActive}
                activeIcon={ExamActiveIcon}
                text={intl.formatMessage({ id: 'A012' })}
              />
              {renderExamCondition()}
            </S.IconWrapper>
          </S.MenuItem>
          <S.ActionItems>
            <S.ActionItem active={popup === 'language'} onClick={toggleLanguagePopup}>
              <LanguageIcon active={popup === 'language'} />
              {popup === 'language' && <S.LanguagePopup closePopup={closePopup} />}
            </S.ActionItem>
            {renderActions()}
          </S.ActionItems>
        </>
      ) }
    </S.Container>
  )
};

export { Header as default };
